// src/features/locker-assignments/components/forms/TagsSection.tsx
import React from 'react';
import { useTranslate } from 'react-admin';
import {
  Box,
  IconButton,
  Chip,
  Tooltip,
} from '@mui/material';
import { 
  Add, 
  Receipt as TagIcon,
} from '@mui/icons-material';
import { MyFormSection } from '@/components';
import type { Tag } from '../../types';

interface TagsSectionProps {
  accessTags: Tag[];
  onAddTag: () => void;
  onRemoveTag: (index: number) => void;
}

export const TagsSection: React.FC<TagsSectionProps> = ({
  accessTags,
  onAddTag,
  onRemoveTag,
}) => {
  const translate = useTranslate();
  
  return (
    <MyFormSection 
      title={translate('resources.locker-assignments.tags.access_tags_count', { count: accessTags.length })}
      icon={<TagIcon />}
    >
      {/* Contenedor principal con diseño horizontal */}
      <Box sx={{ 
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        minHeight: '40px'
      }}>
        {/* Lista de tags a la izquierda */}
        <Box sx={{ 
          display: 'flex', 
          gap: 1, 
          flexWrap: 'wrap',
          flex: 1,
          alignItems: 'center'
        }}>
          {accessTags.length === 0 ? (
            <Box sx={{ 
              color: 'text.secondary', 
              fontSize: '0.875rem',
              fontStyle: 'italic',
              display: 'flex',
              alignItems: 'center',
              py: 0.5
            }}>
              {translate('resources.locker-assignments.tags.no_access_tags')}
            </Box>
          ) : (
            accessTags.map((tag, index) => (
              <Chip
                key={`tag-${index}-${tag.code}`}
                label={`${tag.code}`}
                size='medium'
                onDelete={() => onRemoveTag(index)}
                color="primary"
                variant="outlined"
              />
            ))
          )}
        </Box>
        
        {/* Botón + a la derecha */}
        <Box sx={{ 
          display: 'flex',
          alignItems: 'flex-start'
        }}>
          <Tooltip title={translate('resources.locker-assignments.tags.add_id')}>
            <IconButton 
              size="small"
              color="primary"
              onClick={onAddTag}
              sx={{ 
                border: 1,
                borderColor: 'primary.main',
                bgcolor: 'background.paper',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'primary.contrastText',
                }
              }}
            >
              <Add fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </MyFormSection>
  );
};